module.exports = __webpack_public_path__ + "posture/static/img/spine_sideway_right.21a4c97.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/posture/normal/spine_sideway_right.png
// module id = goN3
// module chunks = 1